const COMMUNICATIONS_ALLOWED_PREFIXES = [
  '/dashboard',
  '/premio',
  '/usuarios',
  '/catalogo',
  '/novedades',
  '/reporteria',
];

const isCommunicationsRole = (userOrToken) => {
  return userOrToken?.role?.type === 'comunications';
};

const canCommunicationsAccessPath = (path) => {
  if (typeof path !== 'string') {
    return false;
  }

  return COMMUNICATIONS_ALLOWED_PREFIXES.some((prefix) => {
    return path === prefix || path.startsWith(`${prefix}/`);
  });
};

export {
  COMMUNICATIONS_ALLOWED_PREFIXES,
  isCommunicationsRole,
  canCommunicationsAccessPath,
};
